const DEV_MODE = false;
const URL = 'http://api.planetmedicalsolutions.com';

let _API = `${URL}/server.php/api`;
let _IMAGES_REPO = `${URL}/public`;
let _IMAGE_UPLOADER = `${URL}/server.php/api/images`;

if (DEV_MODE) {
  _API = '/api';
  _IMAGES_REPO = 'http://localhost:8000';
  _IMAGE_UPLOADER = 'api/images';
}

export const API = _API;
export const IMAGES_REPO = _IMAGES_REPO;
export const IMAGE_UPLOADER = _IMAGE_UPLOADER;



// WEBPACK FOOTER //
// ./src/config.js